import Modal from './Modal';
import { confirm, success, info, error, warning, destroyAll } from './dialog';
export default Object.assign(Modal, { confirm, success, info, error, warning, destroyAll });
